import { api } from './base';

import { ProviderTransactionFilter, ProviderTransactionsPage } from 'v2/types/ProviderTransactionModel';
import { SWRKeyCursorWithExtra } from 'v2/types/swr';
import { normalizeSearch } from 'v2/utils';

export const providerTransactionService = {
  getProviderTransactions([
    _key,
    limit,
    cursor,
    filter,
  ]: SWRKeyCursorWithExtra<ProviderTransactionFilter>): Promise<ProviderTransactionsPage> {
    return api
      .get('v1/admin/provider-transactions', {
        searchParams: normalizeSearch({ ...filter, limit, cursor }),
        // Backend aborts slow queries after 10s with 500; ky's default timeout is also 10s and would win the race.
        timeout: 30_000,
      })
      .json();
  },
};
